import React from 'react';
import PropTypes from 'prop-types';
import LikeButtonWrapper from '../LikeButtonWrapper/LikeButtonWrapper';
import ReplyButtonWrapper from '../ReplyButtonWrapper/ReplyButtonWrapper';
import RepliesCollapseToggleWrapper from '../RepliesCollapseToggleWrapper/RepliesCollapseToggleWrapper';

import './CommentButtons.css';
import { COMMENTS_CONTEXT_SOCIAL_FEED } from '../../utils/constants/commentConstants';
import TranslationButtons from '../TranslationButtons/TranslationButtons';

/**
 * Container that holds the buttons
 * under a comment (Like, Reply)
 */
const CommentButtons = ({
  handleLikeButtonClick,
  isLikedByUser,
  likesCount,
  handleReplyButtonClick,
  hasRepliesCollapse,
  repliesCollapsed,
  handleRepliesCollapseClick,
  repliesCount,
  isDeleted,
  isTranslatable,
  isTranslated,
  isTranslatedError,
  handleTranslateButtonClick,
  isTranslationLoading,
  rootId,
  commentsContext
}) => {
  const likeProps = {
    handleLikeButtonClick,
    isLikedByUser,
    likesCount
  };
  const replyProps = {
    handleReplyButtonClick,
    isLikedByUser,
    likesCount
  };

  const renderLikeButton = () => {
    if (
      !isDeleted &&
      rootId &&
      commentsContext === COMMENTS_CONTEXT_SOCIAL_FEED
    ) {
      return null;
    }

    return <LikeButtonWrapper {...likeProps} />;
  };

  const renderReplyButton = () => {
    if (
      !isDeleted &&
      rootId &&
      commentsContext === COMMENTS_CONTEXT_SOCIAL_FEED
    ) {
      return null;
    }

    return <ReplyButtonWrapper {...replyProps} />;
  };

  return (
    <>
      {isTranslatable && (
        <TranslationButtons
          isTranslationLoading={isTranslationLoading}
          isTranslated={isTranslated}
          isTranslatedError={isTranslatedError}
          handleTranslateButtonClick={handleTranslateButtonClick}
        />
      )}
      <div styleName="like-reply-container">
        {renderLikeButton()}
        {renderReplyButton()}
        {hasRepliesCollapse && (
          <RepliesCollapseToggleWrapper
            handleRepliesCollapseClick={handleRepliesCollapseClick}
            repliesCollapsed={repliesCollapsed}
            repliesCount={repliesCount}
          />
        )}
      </div>
    </>
  );
};

CommentButtons.propTypes = {
  handleLikeButtonClick: PropTypes.func.isRequired,
  isLikedByUser: PropTypes.bool,
  likesCount: PropTypes.number,
  handleReplyButtonClick: PropTypes.func.isRequired,
  hasRepliesCollapse: PropTypes.bool,
  repliesCollapsed: PropTypes.bool,
  handleRepliesCollapseClick: PropTypes.func,
  repliesCount: PropTypes.number,
  isDeleted: PropTypes.bool,
  isTranslatable: PropTypes.bool.isRequired,
  isTranslationLoading: PropTypes.bool.isRequired,
  isTranslated: PropTypes.bool.isRequired,
  isTranslatedError: PropTypes.bool.isRequired,
  handleTranslateButtonClick: PropTypes.func.isRequired,
  rootId: PropTypes.number,
  commentsContext: PropTypes.string
};

CommentButtons.defaultProps = {
  isLikedByUser: false,
  likesCount: 0,
  hasRepliesCollapse: false,
  repliesCollapsed: false,
  handleRepliesCollapseClick: () => {},
  repliesCount: 0,
  isDeleted: false,
  rootId: null,
  commentsContext: null
};

export default CommentButtons;
